module.exports = __webpack_public_path__ + "img/7.e28b9255.jpg";